import React, {useState} from 'react'
import PropTypes from 'prop-types'
import PasswordValidation from './PasswordValidation';
import {
  ShowButton,
  StyledField,
  ShowLabel,
} from './PasswordForm.styled';
import '../../../../../../assets/svgs/showPassword.svg';
import '../../../../../../assets/svgs/hidePassword.svg';
import {StyledFloatLabel} from '../Form.styled';


const Password = ({hasvalue, error, helper, field: {component, id, name, validate, value, label}, ...rest}) => {
  const [showingState, setShowingState] = useState(false);
  const [lowerCaseState, setLowerCaseState] = useState(false);
  const [upperCaseState, setUpperCaseState] = useState(false);
  const [minCharactersState, setMinCharactersState] = useState(false);

  const loverCaseRule = /(?=.*[a-z])/;
  const upperCaseRule = /(?=.*[A-Z])/;
  const minCharacterRule = /^.{6,}$/;

  const valueHandler = e => {
    const value = e.target.value;
    setLowerCaseState(loverCaseRule.test(value));
    setUpperCaseState(upperCaseRule.test(value));
    setMinCharactersState(minCharacterRule.test(value));
  };

  return (
    <>
      <ShowButton onClick={() => setShowingState(!showingState)}>
        {showingState ? (
          <svg height="17" width="20">
            <use xlinkHref="#hidePassword"/>
          </svg>
        ) : (
          <svg height="17" width="20">
            <use xlinkHref="#showPassword"/>
          </svg>
        )}
        <ShowLabel>{showingState ? 'Hide' : 'Show'}</ShowLabel>
      </ShowButton>
      <StyledField
        component={component}
        error={error}
        hasvalue={hasvalue ? 'true' : ''}
        helper={helper}
        id={id}
        name={name}
        onKeyUp={valueHandler}
        type={showingState ? 'text' : 'password'}
        validate={validate}
        value={value}
        {...rest}
      />
      {helper &&
      <PasswordValidation lowerCase={lowerCaseState} minCharacters={minCharactersState}
                          upperCase={upperCaseState} {...rest}/>
      }
      <StyledFloatLabel error={error} hasvalue={hasvalue ? 'true' : ''}
                        htmlFor={id} {...rest}>{label}</StyledFloatLabel>
    </>
  );
};

Password.propTypes = {
  error: PropTypes.string,
  field: PropTypes.shape({
    id: PropTypes.string,
    value: PropTypes.string,
    label: PropTypes.string.isRequired,
    validate: PropTypes.string,
    name: PropTypes.string.isRequired,
    component: PropTypes.oneOf(['input', 'select', 'textarea']),
    options: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        value: PropTypes.any.isRequired,
      }),
    ),
    placeholder: PropTypes.string,
  }),
  hasvalue: PropTypes.bool,
  helper: PropTypes.bool,
  onSubmit: PropTypes.func,
};

export default Password;
